import React, { useContext } from 'react';
import pageClassNames from './HomePageView.module.css'
import { observer } from 'mobx-react-lite';
import { getUserChosenDirectoryHandle } from '../State/FileSystem';
import { CallStackResolutionSelectorView } from '../lib/Causation/CallStackResolutionSelectorView';
import { GlobalContext } from '../components/ExtensionWindow/GlobalContext';
import { ProductName } from "../Styles/ProductName";
import { isRunningInExtension } from './devtools/isProcessRunningInExtensionPage';


export const SettingsPageView = observer( () => {
	const globalContext = useContext(GlobalContext);
	if (globalContext == null) return null;
	const {extensionSettings, licenseCache} = globalContext;
	const updatedPreferredArchiveDirectoryHandle = async () => {
		const directoryHandle = await getUserChosenDirectoryHandle({mode: 'readwrite'});
		if (directoryHandle != null) {
			extensionSettings.updateSettings({archiveDirectoryHandle: directoryHandle});
		}
	}
	const removePreferredArchiveDirectoryHandle = async () => {
		extensionSettings.updateSettings({archiveDirectoryHandle: undefined});
	}
	const preferredDirectoryName = extensionSettings.settings.archiveDirectoryHandle?.name;
	const preferredDirectoryNameIsSet = (preferredDirectoryName?.length ?? 0) > 0;
	return (		
		<div className={pageClassNames.SingleColumnPageContainerElement}><div className={pageClassNames.SingleColumnLeftJustifiedWidthLimited}>
			<h1><ProductName/> — Settings</h1>
			{ licenseCache.mayGenerateCausationGraph == false ? null : (
				<div>
						<label>
						Granularity of causation graph call stacks:&nbsp;
						<CallStackResolutionSelectorView
							defaultValue={extensionSettings.settings.callStackResolution}
							set={ resolution => extensionSettings.updateSettings({callStackResolution: resolution} )}
						/>
					</label>
				</div>			
			)}
			{/* { !isRunningInExtension ? null : (
				<div>
				<label>
					<input type="checkbox" 
								checked={ extensionSettings.settings.startVideoRecordingExtensionStartsRecordingNetwork }
								onChange={ (e) => extensionSettings.updateSettings({startVideoRecordingExtensionStartsRecordingNetwork: e.currentTarget.checked})} />
					Start recording video whenever recording network data
				</label>
				</div>
			)} */}
			{ ((!isRunningInExtension) || licenseCache.mayExportData == false) ? null : (
				<div>
					<label>
						Preferred directory for saving recordings:&nbsp;
						{ preferredDirectoryNameIsSet ?
							(<input type="text" disabled={true} value={extensionSettings.settings.archiveDirectoryHandle?.name ?? ""} />):
							null
						}
						<button onClick={updatedPreferredArchiveDirectoryHandle}>{
							preferredDirectoryNameIsSet ? 'change' : 'set'}</button>
						{ preferredDirectoryNameIsSet ?
							<button onClick={removePreferredArchiveDirectoryHandle}>remove</button>
							: null
						}
					</label>
				</div>
			)} 		
		</div></div>
	);
});
